import { getColormap, getColormapsList } from './colormap.js';
import LookupTable from './lookupTable.js';

export default {
  getColormap,
  getColormapsList,
  LookupTable
};
